import ArrayUtil from "../Utilities/ArrayUtil";

export default class ChangeLanguage {
	languageForm: HTMLFormElement;
	langeuages: HTMLLIElement[];

	constructor() {
		this.languageForm = document.querySelector("#selectLanguage");
		this.langeuages = ArrayUtil.FromNodeList<HTMLLIElement>(this.languageForm.querySelectorAll("li"));

		this.addLanguageSelectClickListener();
	}

	private addLanguageSelectClickListener() {
		this.langeuages.forEach(language => {
			if (!language.classList.contains("active")) {
				language.onclick = (event) => {
					this.setLanguage(event);
				}
			}
		});
	}

	private setLanguage(event: Event) {
		const languageUtil = event.currentTarget as HTMLElement;
		let actionUrl = this.languageForm.action;
		if (actionUrl.indexOf("?") < 0) {
			actionUrl += `?culture=${languageUtil.dataset.lang}`;
		}
		else {
			actionUrl += `&culture=${languageUtil.dataset.lang}`;
		}
		this.languageForm.action = actionUrl;
		this.languageForm.submit();
	}
}
